// mutations
import { showInfoDialog } from '@/api'

import router from '@/router'

const SCHOOLROUTERS_DRIVERS_ALL = (state, RoutesDriversSchool) => {
  if (RoutesDriversSchool.code === 1) {
    state.RoutesDriversSchool = RoutesDriversSchool.data
    state.status = 'success'
  } else {
    alert(RoutesDriversSchool.message)
    state.status = 'error'
  }
}

const SCHOOLROUTERS_DRIVERS_FORM = (state, RoutesDriversSchool) => {
  if (RoutesDriversSchool.code === 1) {
    state.RoutesDriversSchool = RoutesDriversSchool.data
    state.status = 'success'
  } else {
    alert(RoutesDriversSchool.message)
    state.status = 'error'
  }
}

const SCHOOLROUTERS_DRIVERS_SHOW = (state, RoutesDriversSchool) => {
  if (RoutesDriversSchool.code === 1) {
    state.RoutesDriversSchool = RoutesDriversSchool.data
    state.status = 'success'
  } else {
    alert(RoutesDriversSchool.message)
    state.status = 'error'
  }
}

const SCHOOLROUTERS_DRIVERS_CREATE = (state, RoutesDriversSchool) => {
  if (RoutesDriversSchool.code === 1) {
    state.RoutesDriversSchool = RoutesDriversSchool.data
    showInfoDialog("Mensaje informativo",RoutesDriversSchool.message,"Aceptar")
    state.status = 'success'
  } else {
    alert(RoutesDriversSchool.message)
    state.status = 'error'
  }
}

const SCHOOLROUTERS_DRIVERS_UPDATE = (state, RoutesDriversSchool) => {
  if (RoutesDriversSchool.code === 1) {
    state.RoutesDriversSchool = RoutesDriversSchool.data
    showInfoDialog("Mensaje informativo",RoutesDriversSchool.message,"Aceptar")
    state.status = 'success'
  } else {
    alert(RoutesDriversSchool.message)
    state.status = 'error'
  }
}

const SCHOOLROUTERS_DRIVERS_DELETE = (state, RoutesDriversSchool) => {
  if (RoutesDriversSchool.code === 1) {
    state.RoutesDriversSchool = RoutesDriversSchool.data
    state.status = 'success'
  } else {
    alert(RoutesDriversSchool.message)
    state.status = 'error'
  }
}

export default {
  SCHOOLROUTERS_DRIVERS_ALL,
  SCHOOLROUTERS_DRIVERS_FORM,
  SCHOOLROUTERS_DRIVERS_SHOW,
  SCHOOLROUTERS_DRIVERS_CREATE,
  SCHOOLROUTERS_DRIVERS_UPDATE,
  SCHOOLROUTERS_DRIVERS_DELETE
}



// WEBPACK FOOTER //
// ./src/store/modules/schoolroutes/drivers/mutations.js